import { render, staticRenderFns } from "./GameDefinition.vue?vue&type=template&id=8393977c&scoped=true&"
import script from "./GameDefinition.vue?vue&type=script&lang=js&"
export * from "./GameDefinition.vue?vue&type=script&lang=js&"
import style0 from "./GameDefinition.vue?vue&type=style&index=0&id=8393977c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8393977c",
  null
  
)

export default component.exports